/**
 * @generated SignedSource<<fe2021d7961b5dcc938040a5750b191f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SwiperItem_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useValidFilter_itemSearch">;
  readonly " $fragmentType": "SwiperItem_itemSearch";
};
export type SwiperItem_itemSearch$key = {
  readonly " $data"?: SwiperItem_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SwiperItem_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwiperItem_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useValidFilter_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "223572b52604ed0a9d81b9d73297b437";

export default node;
